import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const defaultConfig = {
  settings: {
    allowMultiplePrefixes: false, //not used
    allowMultipleSuffixes: false, //not used
    slideCount: 10,
    availableLevels: [1, 2, 3],
    defaultLevel: 2,
  },
  baseWord: {
    value: "sign",
    latin: "", //not used
    description: "",
    requiresSubscription: false, //not used
  },
  resources: [
    {
      name: "Level 1",
      url: "/resources/sign-level-1-resouces.pdf",
    },
    {
      name: "Level 2",
      url: "/resources/sign-level-2-resouces.pdf",
    },
    {
      name: "Level 3",
      url: "/resources/sign-level-3-resouces.pdf",
    },
  ],
  L1ValidWords: new Set(["sign"]),
  L1WordsWithRulesApplied: [],
  L2ValidWords: new Set(["sign"]),
  L2WordsWithRulesApplied: [],
  L3ValidWords: new Set(["sign"]),
  L3WordsWithRulesApplied: [],
};
